import script from "./GlobalBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./GlobalBreadcrumb.vue?vue&type=style&index=0&id=5d18b2b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d18b2b7"]])

export default __exports__